import BackendClient from './backendClient';
import {
	readApiEndpointV1,
	writeApiEndpointV1,
} from '../utils/config';

export const getFormTemplates = (accountId) =>
	BackendClient.get(`${readApiEndpointV1}accounts/${accountId}/forms`);

export const getFormTemplate = (accountId, formTemplateId) =>
	BackendClient.get(`${readApiEndpointV1}accounts/${accountId}/forms/${formTemplateId}`);

export const createFormTemplate = (accountId, body) =>
	BackendClient.post(`${writeApiEndpointV1}accounts/${accountId}/forms`, body);

export const updateFormTemplate = (accountId, formTemplateId, body) =>
	BackendClient.put(
		`${writeApiEndpointV1}accounts/${accountId}/forms/${formTemplateId}`,
		body,
		false,
		false
	);

export const deleteFormTemplate = (accountId, formTemplateId) =>
	BackendClient.delete(`${writeApiEndpointV1}accounts/${accountId}/forms/${formTemplateId}`);

export const applyFormTemplate = (accountId, mediaId, formTemplateId, linkType = 'Form') =>
	BackendClient.post(`${writeApiEndpointV1}accounts/${accountId}/medias/${mediaId}/links`, { type: linkType, id: formTemplateId });

export const undoFormTemplate = (accountId, mediaId, formTemplateId, linkType = 'Form') =>
	BackendClient.delete(`${writeApiEndpointV1}accounts/${accountId}/medias/${mediaId}/links?type=${linkType}&id=${formTemplateId}`);

export const fetchFormRegistrations = (accountId, formTemplateId, mediaId = '', searchKey = '', offset = 0) =>
	BackendClient.get(`${readApiEndpointV1}accounts/${accountId}/forms/${formTemplateId}/registrations?limit=50&offset=${offset}&q=${searchKey}&mediaId=${mediaId}`);

export const deleteFormRegistration = (accountId, formTemplateId, registrationId) =>
	BackendClient.delete(`${writeApiEndpointV1}accounts/${accountId}/forms/${formTemplateId}/registrations/${registrationId}`);

export const exportFormRegistrations = (accountId, formTemplateId) =>
	BackendClient.getBlob(`${readApiEndpointV1}accounts/${accountId}/forms/${formTemplateId}/registrations/export`);

export const notifyEventChange = (accountId, formTemplateId, mediaId, newDate) =>
	BackendClient.post(`${writeApiEndpointV1}accounts/${accountId}/forms/${formTemplateId}/registrations/notify-event-changed`, { mediaId, newDate });
